import React from 'react';
import { Dropdown } from 'react-bootstrap';
import styled from 'styled-components';

export default function FilterDropdown({ list, value, setValue }) {
	return (
		<Dropdown bsPrefix='filter-dropDown'>
			<Dropdown.Toggle variant='secondary'>{value}</Dropdown.Toggle>

			<Dropdown.Menu variant='dark'>
				{list.map((item, index) => {
					return (
						<Dropdown.Item
							key={index}
							active={item === value}
							onClick={() => setValue(item)}
						>
							{item}
						</Dropdown.Item>
					);
				})}
				<Dropdown.Divider />
				<Dropdown.Item href='#/action-4'>Separated link</Dropdown.Item>
			</Dropdown.Menu>
		</Dropdown>
	);
}

const Container = styled.div`
	border: 1px solid var(--button-border-color);
	border-radius: 5px;
	padding: 7px 17px;
	font-family: 'NotoSansRg';
	font-weight: 500;
	font-size: 12px;
	text-align: ${props => props.textalign};
`;

const Text = styled.span`
	color: var(--third-text-color);
`;
